import { useQuery } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';

/**
 * GET /api/eraf/saga-monitor/summary — 상태별 사가 집계
 * queryKey: ['saga-monitor', 'summary']
 */
export function useSagaSummary() {
  return useQuery({
    queryKey: ['saga-monitor', 'summary'],
    queryFn: () => sagaMonitorApi.getSummary(),
    staleTime: 15_000,
  });
}
